//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import {
  AbstractProgramModel,
  AbstractProgramNavModel,
} from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";

@PresenterRegistration({ 
  types: [AbstractProgramNavModel],
  key: "subMenu",
})
@Component({
  selector: "programs-submenu",
  standalone: false,
  templateUrl: "./programs-submenu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramsSubmenuComponent<TProgram extends AbstractProgramModel> {
  public data: WritableSignal<AbstractProgramNavModel<TProgram>> = signal<AbstractProgramNavModel<TProgram>>(null);
}
